import React from "react";
import FavsList from "./lists/FavsList";

function MaListe() {

    return (
        <section>
            <div className="container_news favs">
                <h3 className="categorie">Ma Liste</h3>
                <FavsList />
            </div>
        </section>
        
    )
}

export default MaListe;